<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import Button from "./Button.svelte";
	import translations from "./CareerSection.translations.json";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import type { Position } from "../../../core/schema/Position.js";
	import CareerItem from "./CareerItem.svelte";
	import CareerFormModal from "./Career/CareerFormModal.svelte";

	export let positions: Position[];
	export let headline: string | undefined = undefined;

	const translate = getTranslate(translations);

	let showCareerModal = false;
</script>

<div class="py-[1.875rem]">
	<div class="mx-4 text-center md:mx-16 xl:mx-32">
		<h2 class="font-roboto text-ltprimary mb-4 font-light uppercase tracking-wider lg:!text-2xl">
			{headline ?? translate("headline")}
		</h2>
		<p class="font-lexend text-ltsecondary !text-md md:!text-2md mx-auto mb-8 font-light md:mb-16">
			{translate("subheadline ")}
		</p>
	</div>

	<div class="border-lttertiary m-6 border-y">
		<div class="mx-auto max-w-[120rem] md:px-[5.125rem] xl:px-[8.063rem]">
			<div class="border-lttertiary border-x">
				{#each positions as position (position.id)}
					<CareerItem {position} />
				{/each}
			</div>
		</div>
	</div>

	<div class="mx-4 mt-12 text-center md:mx-16 md:mt-16 xl:mx-32">
		<p class="text-2xs/normal mx-auto !mb-0 !font-normal tracking-wider lg:text-base/normal">{translate("desc1")}</p>
		<p class="text-2xs/normal mx-auto !mb-0 !font-normal tracking-wider lg:text-base/normal">{translate("desc2")}</p>
		<Button
			variant="secondary"
			class="mx-auto mt-12 md:mt-16"
			icon={arrowRight}
			on:click={() => (showCareerModal = true)}
		>
			{translate("sendCv")}
		</Button>
	</div>
</div>

<CareerFormModal bind:show={showCareerModal} />
